import { useItemSet } from '@exam-management/common/item-set-provider';
import { type ConfirmationModalProps } from '@shared/components';
import { useSnackbar } from '@shared/snackbar';

import { DisableQuestionModal } from '../../components';

type DisableItemSetQuestionModalProps = Pick<ConfirmationModalProps, 'onClose' | 'open'>;

export default function DisableItemSetQuestionModal(
  props: Readonly<DisableItemSetQuestionModalProps>,
) {
  const { open: isOpen, onClose } = props;

  const { disable, isDisabling } = useItemSet();
  const { showSnackbar } = useSnackbar();

  const handleAccept: React.MouseEventHandler<HTMLButtonElement> = async (event) => {
    await disable({
      onCompleted: () => {
        showSnackbar({
          message: 'Question has been disabled',
          variant: 'success',
        });
        onClose?.(event);
      },
      onError: () => {
        showSnackbar({
          message: 'Unable to Disable Question',
          variant: 'error',
        });
        onClose?.(event);
      },
    });
  };

  const handleClose: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    onClose?.(event);
  };

  return (
    <DisableQuestionModal
      open={isOpen}
      loading={isDisabling}
      onClose={handleClose}
      onAccept={handleAccept}
    />
  );
}
